import { Select } from 'antd';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useAccountingYear } from './hooks/useAccountingYear';

export function AccountingYearPicker({
  earliestYear,
}: {
  earliestYear: number;
}) {
  const [params, setParams] = useSearchParams();
  const currentYear = dayjs().year();
  // Same resolution the cards use, so the Select can't show a year the figures
  // below it aren't for.
  const selected = useAccountingYear(earliestYear);
  const years: number[] = [];
  for (let y = currentYear; y >= earliestYear; y--) years.push(y);

  return (
    <Select
      value={selected}
      style={{ width: 120 }}
      onChange={(v) => {
        params.set('year', String(v));
        setParams(params);
      }}
      options={years.map((y) => ({ value: y, label: String(y) }))}
    />
  );
}
